import { useState } from "react";
import { addDays } from "../../lib/date";
import { useUi } from "../../state/ui";
import { EventList } from "./EventList";
import { useVisibleEvents } from "./common";

/** "Programação": everything from the selected day on, loading further on demand. */
export function ScheduleView() {
  const ui = useUi();
  const [span, setSpan] = useState(60);
  const { events, holidays, loading } = useVisibleEvents(ui.date, addDays(ui.date, span));
  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      {loading ? (
        <div className="center-fill" style={{ height: 200 }}>
          <div className="spinner" />
        </div>
      ) : (
        <EventList events={events} holidays={holidays} emptyText="Nada agendado a partir desta data." />
      )}
      {span < 360 && (
        <div style={{ textAlign: "center", paddingBottom: 32 }}>
          <button className="btn outline" onClick={() => setSpan((s) => s + 60)}>
            Mostrar mais
          </button>
        </div>
      )}
    </div>
  );
}
